module.exports = __webpack_public_path__ + "img/more_pay.84c7abf5.png";